// var md = new MobileDetect(window.navigator.userAgent);

var $ = jQuery.noConflict();


$(document).ready(function () {
	if ($('.gallery-block').length > 0) {
		$('.gallery-block').each(function () {
			var galleryThumbs = new Swiper($(this).find('.gallery-thumbs')[0], {
				direction: 'vertical',
				spaceBetween: 10,
				slidesPerView: 6,
				freeMode: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				navigation: {
					nextEl: $(this).find('.swiper-button-next')[0],
					prevEl: $(this).find('.swiper-button-prev')[0],
				},
			});
			var galleryTop = new Swiper($(this).find('.gallery-top')[0], {
				spaceBetween: 10,
				thumbs: {
					swiper: galleryThumbs
				}
			});
		});
	}
	if ($('.swiper-block').length > 0) {
		$('.swiper-block').each(function () {

			var swiper = new Swiper($(this)[0], {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				autoplay: {
					delay: 5000,
				},
				pagination: {
					clickable: true,
					el: $(this).find('.swiper-pagination')[0],
				},
				on: {
					transitionEnd: function () {

						$('.swiper-slide:not(.swiper-slide-active)').find('video').each(function () {
							this.pause();
						});
						$('.swiper-slide-active').find('video').each(function () {
							this.play();
						});
					}
				}
			});
		});
	}
	// $('map').imageMapResize();
	$(document).on('click', '.pum-trigger', function (e) {
		e.preventDefault();
	});

	if ($('.durability-slider-block').length > 0) {
		$('.swiper-durability-block').each(function () {

			var swiper = new Swiper($(this)[0], {
				effect: 'fade',
				loop: true,
				fadeEffect: {
					crossFade: true
				},
				autoplay: {
					delay: 5000,
				},
				navigation: {
					prevEl: '.swiper-durability-button-prev',
					nextEl: '.swiper-durability-button-next',
				},
				breakpoints: {
					1040: {
						navigation: false,
						pagination: {
							clickable: true,
							el: $(this).find('.swiper-pagination')[0],
						},
					}
				}
			});
		});
	}
	if ($('.connector-swiper').length > 0) {
		$('.connector-swiper').each(function () {

			var swiper = new Swiper($(this)[0], {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				autoplay: {
					delay: 5000,
				},
				navigation: {
					prevEl: '.swiper-button-prev',
					nextEl: '.swiper-button-next',
				},
			});
		});
	}
	if ($('.swiper-usage').length > 0) {
		$('.swiper-usage').each(function () {

			var swiper = new Swiper($(this)[0], {
				effect: 'fade',
				loop: true,
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					prevEl: '.usage-left',
					nextEl: '.usage-right',
				},
				on: {
					transitionStart: function () {
						$('.usage-pagination .navigation-item').removeClass('active');
						$('.usage-pagination .navigation-item[data-index="' + this.realIndex + '"]').addClass('active');
					},
				},
			});

			$('.usage-pagination .navigation-item').click(function () {
				var index = $(this).data('index') + 1;
				swiper.slideTo(index);
			});
		});

	}

	if ($('#dopasowany_siedem')) {

		$('#dopasowany_bazowa img').mouseover(function () {
			$('#dopasowany_taras_bazowa').addClass('active');
			$('#dopasowany_uzupelniajace img').addClass('hide');
		}).mouseout(function () {
			$('#dopasowany_taras_bazowa').removeClass('active');
			$('#dopasowany_uzupelniajace img').removeClass('hide');
		});

		$('#dopasowany_uzupelniajace img').mouseover(function () {
			$('#dopasowany_taras_uzupelniajace').addClass('active');
			$('#dopasowany_bazowa img').addClass('hide');
		}).mouseout(function () {
			$('#dopasowany_taras_uzupelniajace').removeClass('active');
			$('#dopasowany_bazowa img').removeClass('hide');
		});

	}


	var mobileUsageItems = $('.mobile-usage-item');

	mobileUsageItems.click(function () {
		var tt = $(this);
		if (tt.hasClass('active')) {
			mobileUsageItems.removeClass('active');
		} else {
			mobileUsageItems.removeClass('active');
			tt.addClass('active');
		}
	});

	$(window).scroll(function () {
		var scroll = $(window).scrollTop();

		//>=, not <=
		if (scroll >= 500) {
			//clearHeader, not clearheader - caps H
			$('header.scrollable').addClass("mini");
		} else {
			$('header.scrollable').removeClass("mini");
		}

	});

	$('.faq-block').each(function () {
		$(this).find('.name').click(function () {
			$(this).toggleClass('active');
			$(this).next().toggleClass('active');
		});
	});


	if ($('.lacznik').length) {

		$('.lacznik_txt').each(function () {
			$(this).mouseenter(function () {
				if (!$(this).hasClass('active')) {
					$('.lacznik_txt.active').removeClass('active');
					$('.lacznik.active').removeClass('active');
					$(this).addClass('active');
					$('#' + $(this).attr('data-show')).addClass('active');
				}
			});
		});


	}


	jQuery('.menu-bt').click(function () {
		jQuery(this).toggleClass('is-active');
		jQuery('header').toggleClass('is-active');
	});
	if (jQuery('#region_choose')) {
		jQuery('#region_choose').on('change', function () {
			change_region(jQuery('#region_choose').val());
		}).trigger('change');
	}
	if (jQuery('#polska')) {
		jQuery('#polska area').on('click', function () {
			change_region(jQuery(this).attr('title'));
		});
	}

	jQuery('#billing_invoice_ask').change(function () {

		if (jQuery(this).is(':checked')) {
			jQuery('#billing_vat_number_field').addClass("active");
			jQuery('#billing_vat_number').prop("required", true);
		} else {
			jQuery('#billing_vat_number_field').removeClass("active");
			jQuery('#billing_vat_number').prop("required", false);

		}
	});
});

function change_region(new_region) {
	// jQuery('.no-partners').removeClass('active');
	jQuery('#partners_list .partner_one').removeClass('active');

	if (new_region) {
		jQuery('#partners_list .partner_one[data-region=' + new_region + ']').addClass('active');
	} else {
		jQuery('#partners_list .partner_one').addClass('active');
	}
	jQuery('.no-partners').removeClass('active');
	jQuery('#polska .region_map.active').removeClass('active');
	if (new_region) {
		jQuery('#polska .region_map[data-region=' + new_region + ']').addClass('active');
	}
	jQuery('#region_choose').val(new_region);

	if (jQuery('#partners_list .partner_one.active').length === 0) {
		jQuery('.no-partners').addClass('active');
	}

}

function copyToClipboard(element) {
	var $temp = jQuery("<input>");
	jQuery("body").append($temp);
	$temp.val(jQuery(element).text()).select();
	document.execCommand("copy");
	$temp.remove();
}
